// Lazy facade over sweetalert2 for modules that sit in the entry chunk (HAP-4635).
//
// sweetalert2 is ~72 KB raw and every boot-path caller only uses it from event
// handlers, so it is fetched on first use. Supported surface (all async):
//   Swal.fire(...)        -> Promise<SweetAlertResult>   (same as the real one)
//   new Swal(...)         -> Promise<SweetAlertResult>   (legacy constructor form)
//   Swal.close()          -> closes once loaded (queued behind any pending fire)
// Anything else (showLoading, isVisible, mixin…) — import 'sweetalert2' directly.
// The stylesheet is still imported globally by helpers/Mango.vue.

let loading = null
const load = () => (loading ||= import('sweetalert2').then((m) => m.default))

function Swal(...args) {
	// `new Swal(...)` returns this promise because it is an object.
	return load().then((S) => S.fire(...args))
}
Swal.fire = (...args) => load().then((S) => S.fire(...args))
Swal.close = (...args) => {
	if (!loading) return
	return load().then((S) => S.close(...args))
}

export default Swal
